export enum PreferredContact {
  EMAIL = 'email',
  PHONE = 'telephone',
  EMAIL_PHONE = 'emailAndTelephone'
}

export enum ContactFields {
  EMAIL = 'contactEmail',
  PHONE = 'contactPhone'
}
